module.exports = __webpack_public_path__ + "media/photo1.662fccfa.mp4";